// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__2fudy","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2Kmh0","obliqueLine":"membershipbadge_obliqueLine__2W5Cv"};